import { render, staticRenderFns } from "./ModalTransition.vue?vue&type=template&id=055f6722"
import script from "./ModalTransition.vue?vue&type=script&lang=js"
export * from "./ModalTransition.vue?vue&type=script&lang=js"
import style0 from "./ModalTransition.vue?vue&type=style&index=0&id=055f6722&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports